import React from 'react';
import {FaCircleExclamation, FaTriangleExclamation} from "react-icons/fa6";

const DocumentsCellRenderer = ({value}) => {
    return (
        <>
            {
                value === "expired" &&
                <span className={"text-red-500 flex items-center"}>
                    <FaTriangleExclamation className={"mr-2"} color={"red"}/> Vencido
                </span>
            }

            {
                value === "toExpire" &&
                <span className={"text-orange-500 flex items-center"}>
                    <FaCircleExclamation className={"mr-2"} color={"orange"}/> A vencer
                </span>
            }

        </>
    )
};

export default DocumentsCellRenderer;